import React from 'react';
import { Input } from './ui/input';
import QuestionCard from './QuestionCard';

interface TieBreakerQuestionProps {
  questionId?: string;
  title?: string;
  description: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  points?: number;
  earnedPoints?: number;
}

export const TieBreakerQuestion: React.FC<TieBreakerQuestionProps> = ({
  questionId,
  title = 'Daily Tie Breaker',
  description,
  value,
  onChange,
  disabled = false,
  points = 0,
  earnedPoints,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;

    // Prevent values longer than 4 characters (prevents numeric overflow)
    if (newValue.length <= 4) {
      onChange(newValue);
    }
  };

  return (
    <QuestionCard
      points={points}
      earnedPoints={earnedPoints}
      hidePointsIcon={true}
      className="border-2 border-[#333333] bg-black"
      data-test-id={questionId ? `question-${questionId}` : 'tiebreaker-container'}
      data-test-type="tiebreaker"
    >
      <h3 className="text-text-primary text-lg font-gilroy font-bold mb-4 text-center">{title}</h3>
      <p className="text-text-secondary text-base font-gilroy font-light mb-4 text-center">{description}</p>
      <div className="flex justify-center">
        <Input
          data-test-id="tiebreaker-input"
          type="number"
          inputMode="numeric"
          pattern="[0-9]*"
          maxLength={4}
          value={value}
          onChange={handleChange}
          disabled={disabled}
          className="bg-white text-black text-center text-2xl font-gilroy border-0 w-[33%] [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
          aria-label="Tiebreaker answer (max 4 digits)"
        />
      </div>
    </QuestionCard>
  );
};